import { replace } from "react-router-redux/actions";
const MODULE_NAME = "sc/actions/ui/location/";

// Actions
export const DETECTED_LOCATION = `@@${MODULE_NAME}DETECTED_LOCATION`;

// Creators
export const detectedLocation = location => ({
  type: DETECTED_LOCATION,
  payload: {
    location: location,
  },
});

export const showErrorPage = () => replace("/error");



// WEBPACK FOOTER //
// ./src/sc/actions/ui/location.js